$(document).on('click', '.offer-search-query-submit-btn', function() {

  // フォームデータを取得
  const formDataArray = $('#offer-form').serializeArray();

  const conditionsFilled = formDataArray.some(param => param.name.startsWith('search_offer_form') && param.value);
  if (!conditionsFilled) {
    alert('少なくとも1つの検索条件を入力してください。');
    return;
  }

  // 検索条件名を取得
  const offerName = $('input[name="offer_search_query[title]"]').val();

  if (!offerName) {
    alert('検索条件名を入力してください。');
    return;
  }

  // 検索条件名をフォームデータに追加
  formDataArray.push({ name: 'offer_search_query[title]', value: offerName });

  // フォームデータをクエリストリング形式に変換
  const params = $.param(formDataArray);


  $.ajax({
    url: `/mypage/sc/offer_search_queries`,
    type: 'POST',
    data: params, // 送信するデータ（フォームのデータ）
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    success: function(data) {
      if (data.status === 'success') {
        // 成功時のモーダル内容に書き換え
        $('#uploadsave .modal-contents').html(`
          <div class="-inner">
            <p class="-text u-text-center">検索条件を保存しました。</p>
          </div>
          <div class="u-flex" style="justify-content: center;">
            <a class="c-btn c-btn__bg-blue" href="/mypage/sc/offer_search_queries">保存した検索条件へ</a>
          </div>
        `);
      } else {
        console.error(data.message);
      }
    },
    error: function(xhr, status, error) {
      // エラーメッセージを取得
      const errorMessage = xhr.responseJSON.message || 'エラーが発生しました。';

      // モーダル内容を更新
      $('.modal-contents').html(`
        <div class="-inner">
          <p class="-text u-text-center">保存できる上限は6件までです。<br>追加で保存される場合は、<br>「保存した検索条件」から検索条件を削除後、再度保存してください。</p>
          <p class="-text u-text-center color-red">${errorMessage}</p>
        </div>
        <div class="u-flex" style="justify-content: center;">
          <a class="c-btn c-btn__bg-blue" href="/mypage/sc/offer_search_queries"">保存した検索条件へ</a>
        </div>
      `);
    }
  });
});

